module.exports = __webpack_public_path__ + "static/media/20b-01-HOME_ST-2020-426x464mm-oleo-sobre-madera.8888fec6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/20b/20b-01-HOME_ST-2020-426x464mm-oleo-sobre-madera.jpg
// module id = 246
// module chunks = 0